// In src/pages/llm-response/index.tsx
import CallflowSciptTool from 'src/components/callflow-script'; // Default import

// import AdminToolInfo from "../../components/admin-tool-info";

const CallflowScipt: React.FC = () => {
	return <CallflowSciptTool />;
};
export default CallflowScipt;
